import { render, staticRenderFns } from "./reserve-select-main-type.vue?vue&type=template&id=1acbd59e&scoped=true&lang=pug"
import script from "./reserve-select-main-type.vue?vue&type=script&lang=js"
export * from "./reserve-select-main-type.vue?vue&type=script&lang=js"
import style0 from "./reserve-select-main-type.vue?vue&type=style&index=0&id=1acbd59e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acbd59e",
  null
  
)

export default component.exports